const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-background-img">
        <div className="text-container">
          <p className="hero-text">
            The
            <span className="hero-text-color"> Best</span>
          </p>
          <p className="hero-text">
            <span className="hero-text-color">Foods </span>Delivery
          </p>
        </div>
      </div>
      <div className="overlay-hero"></div>
    </div>
  );
};

export default Hero;
